import { AccordionDetails, Button, List, ListItem } from "@mui/material";
import { useNavigate } from "react-router-dom";

export const DownloadDetailComponent = () => {
  const navigate = useNavigate();
  return (
    <AccordionDetails sx={{ pl: 0 }}>
      <List disablePadding>
        <ListItem>
          <Button
            sx={{ textTransform: "none" }}
            onClick={() => navigate("/how-to-add-ios")}
          >
            iPhoneをお使いの方
          </Button>
        </ListItem>
        <ListItem>
          <Button
            sx={{ textTransform: "none" }}
            onClick={() => navigate("/how-to-add-other")}
          >
            Android端末をお使いの方
          </Button>
        </ListItem>
      </List>
    </AccordionDetails>
  );
};
